"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.impactTypeAddApi = impactTypeAddApi;
exports.impactTypeBulkHardDeleteApi = impactTypeBulkHardDeleteApi;
exports.impactTypeBulkRestoreApi = impactTypeBulkRestoreApi;
exports.impactTypeBulkSoftDeleteApi = impactTypeBulkSoftDeleteApi;
exports.impactTypeDeleteApi = impactTypeDeleteApi;
exports.impactTypeFetchApi = impactTypeFetchApi;
exports.impactTypeGetListApi = impactTypeGetListApi;
exports.impactTypePaletteListApi = impactTypePaletteListApi;
exports.impactTypeSoftDeleteApi = impactTypeSoftDeleteApi;
exports.impactTypeSoftDeleteRestoreApi = impactTypeSoftDeleteRestoreApi;
exports.impactTypeSoftDeletedListApi = impactTypeSoftDeletedListApi;
exports.impactTypeUpdateApi = impactTypeUpdateApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * fetch impactType list with id and year
 * @param payload
 * @returns api response
 * @description this function used to fetch impactType with id and year.
 */
function impactTypeGetListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.list), params);
}

/**
 * fetch impactType list with id and year
 * @param payload
 * @returns api response
 * @description this function used to fetch impactType with id and year.
 */
function impactTypePaletteListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.paletteList), params);
}

/**
 * fetch impactType list with id and year
 * @param payload
 * @returns api response
 * @description this function used to fetch impactType with id and year.
 */
function impactTypeFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.fetch), params);
}

/**
 * impactType add
 * @param payload
 * @returns api response
 * @description this function used to impactType add given inputs.
 */
function impactTypeAddApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.add), payload);
}

/**
 * impactType update
 * @param payload
 * @returns api response
 * @description this function used to update impactType given inputs.
 */
function impactTypeUpdateApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.update), payload);
}

/**
 * impactType delete
 * @param payload
 * @returns api response
 * @description this function used to delete impactType of given params.
 */
function impactTypeDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.delete), params);
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
function impactTypeSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.softDelete), params);
}

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
function impactTypeSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.softDeleteRestore), params);
}

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
function impactTypeSoftDeletedListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.softDeletedList), params);
}

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
function impactTypeBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.bulkSoftDelete), params);
}

/**
 * bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
function impactTypeBulkHardDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.bulkHardDelete), params);
}

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
function impactTypeBulkRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impactType.bulkRestore), params);
}